import { render, staticRenderFns } from "./ClientReservationInfo.vue?vue&type=template&id=d021c0d8&"
import script from "./ClientReservationInfo.vue?vue&type=script&lang=js&"
export * from "./ClientReservationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports